<template>
  <v-form ref="form" lazy-validation >
  <v-card class="p-3">
    <v-card-title>Filter Tagged Groups</v-card-title>
    <v-card-text>
      <v-row align="end">
        <v-col cols="4">
         <v-checkbox
            v-model="onlyNeedsReview"
            :label="'Tagger marked as questionable'"
         ></v-checkbox>
        </v-col>

        <v-col cols="4">
         <v-checkbox
            v-model="showQCed"
            :label="'Show groups already QCed'"
         ></v-checkbox>
        </v-col>

        <v-col cols="4">
         <v-checkbox
            v-model="includeInactive"
            :label="'Include inactive photos'"
         ></v-checkbox>
        </v-col>
      </v-row>
      <v-row align="end">
        <v-col cols="4">
          <date-picker v-model="fromDateVal" :initial-value="defaultFromDt" label="Tagged Date From"/>
        </v-col>
        <v-col cols="4">
          <date-picker v-model="thruDateVal" :initial-value="defaultToDt" label="Tagged Date Thru"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-autocomplete v-model="selectedTaggers"
                          :items="users"
                          :filter="taggerFilter"
                          chips
                          class="mt-4"
                          label="Taggers"
                          multiple
                          small-chips
          >
            <template v-slot:selection="data">
              <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeTaggerFromSelected(data.item)"
              >
                <div style="overflow: hidden">{{ data.item.email }}</div>
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title v-html="`${data.item.email}`"></v-list-item-title>
              </v-list-item-content>
            </template>

          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4">
          <v-autocomplete :items="allCats"
                          class="mt-4" item-text="name" item-value="id"
                          label="Tag Category" @input="filterTagByCategory"/>
        </v-col>

        <v-col cols="8">
          <v-autocomplete v-model="selectedTags"
                          :filter="tagFilter"
                          :items="filteredTags"
                          :search-input.sync="tagSearchInput"
                          chips
                          class="mt-4"
                          label="Tags"
                          multiple
                          small-chips
                          @change="tagSearchInput=''"
          >
            <template v-slot:selection="data">
              <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeTagFromSelected(data.item)"
              >
                {{ data.item.name }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                <v-list-item-subtitle v-if="data.item.category"
                                      v-html="data.item.category.name"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-autocomplete v-model="selectedProjects"
                          :items="getProjects"
                          chips class="mt-4"
                          item-text="name" item-value="id"
                          label="Projects" multiple return-object small-chips clearable
          />
        </v-col>
        <v-col cols="6">
          <v-autocomplete v-model="selectedJobs"
                          :items="getJobs"
                          chips class="mt-4"
                          item-text="name" item-value="id"
                          label="Jobs" multiple return-object small-chips clearable
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols='6'>
            <v-select v-model='selectedDepartment'
              label='Department'
              :items='departmentChoices'
              :loading='$store.state.loading_list.includes("get_department_list")'
              clearable />
        </v-col>
        <v-col cols='6'>
            <v-autocomplete
              v-model='selectedCountry'
              :items='countries'
              item-text='label'
              item-value='value'
              label='Country'
              clearable />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols='4'>
            <v-select v-model='selectedRetailer'
              label='Retailer'
              :items='retailerChoices'
              :loading='$store.state.loading_list.includes("get_retailer_list")'
              clearable />
        </v-col>
        <v-col cols='4'>
            <!-- IT-703: named rgidSearchFreeForm to match PhotoFilter. It was
                 `groupId` here, which the shared store action does not read, so
                 the value was collected, chipped as applied, and dropped. -->
            <v-text-field
              v-model="rgidSearchFreeForm"
              label="Response Group ID Search"
              clearable
            ></v-text-field>
        </v-col>
        <v-col cols='4'>
            <!-- IT-703: this page had no response-id search at all, which is
                 what Rebecca hit — "there isn't a spot to enter a response ID
                 under group-qc". -->
            <v-text-field
              v-model="respIdSearchFreeForm"
              label="Response ID Search"
              clearable
            ></v-text-field>
        </v-col>
        <v-col cols='4'>
            <v-text-field
              v-model="question_id"
              label="Question ID"
              clearable
            ></v-text-field>
        </v-col>
      </v-row>

    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" text @click="cancelClicked()">
        Cancel
      </v-btn>
      <v-btn color="success" text @click="okClicked()">
        Ok
      </v-btn>
    </v-card-actions>

  </v-card>
    </v-form>
</template>

<script>
import DatePicker from './DatePicker.vue'
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'GroupQCFilterModal',
  components: {
    DatePicker
  },
  props: {
    photoFilters: {
      type: Object
    },
    retailerChoices: {
      type: Array,
      default: () => []
    },
    departmentChoices: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      selectedTags: [],
      selectedTaggers: [],
      tagSearchInput: null,
      fromDateVal: null,
      thruDateVal: null,
      filteredTags:[],
      onlyNeedsReview: false,
      showQCed: false,
      includeInactive: false,
      selectedRetailer: null,
      selectedProjects: [],
      selectedJobs: [],
      selectedDepartment: null,
      selectedCountry: null,
      // Mirrors PhotoFilterModal rather than being fetched. Keeping two copies
      // in step is a P2.2 concern — one modal, one list.
      countries: [
        {value: 'US', label: 'United States'},
        {value: 'CA', label: 'Canada'},
      ],
      rgidSearchFreeForm: null,
      respIdSearchFreeForm: null,
      question_id: null,
    }
  },
  mounted() {
    this.filteredTags = this.tags
    this.selectedTags = this.photoFilters.tags
    this.selectedTaggers = this.photoFilters.taggers
    this.onlyNeedsReview = this.photoFilters.onlyNeedsReview
    this.showQCed = this.photoFilters.showQCed
    this.includeInactive = this.photoFilters.includeInactive === true

    if (this.photoFilters.fromDt != null) {
      this.fromDateVal = this.photoFilters.fromDt
    }

    if (this.photoFilters.thruDt != null) {
      this.thruDateVal = this.photoFilters.thruDt
    }

    this.selectedRetailer = this.photoFilters.retailer
    this.selectedProjects = this.photoFilters.projects || []
    this.selectedJobs = this.photoFilters.jobs || []
    this.selectedDepartment = this.photoFilters.department
    this.selectedCountry = this.photoFilters.country
    this.rgidSearchFreeForm = this.photoFilters.rgidSearchFreeForm
    this.respIdSearchFreeForm = this.photoFilters.respIdSearchFreeForm
    this.question_id = this.photoFilters.question_id

    this.$emit('modal-mounted', true)
  },
  computed: {
    ...mapState({
      tags: state => state.tags.tags,
      categories: state => state.categories.categories,
      users: state => state.users.users
    }),
    // App.vue / Login.vue populate these app-wide, so the lists are loaded by
    // the time this modal opens — no per-view fetch needed.
    ...mapGetters(['getProjects', 'getJobs']),
    allCats() {
      let cats = this.categories
      cats = cats.map(cat => ({id: cat.id, name: cat.name}))
      cats.push({id: 0, name: 'All'})
      return cats
    },
    defaultFromDt() {
      return this.fromDateVal;
    },
    defaultToDt() {
      return this.thruDateVal;
    }
  },
  methods: {
    removeTaggerFromSelected(tagger){
      let index = this.selectedTaggers.indexOf(tagger)
      if (index >=0) this.selectedTaggers.splice(index, 1)
    },
    taggerFilter(item, queryText, itemText){
      const cleanName = item.email.toLowerCase()
      const searchText = queryText.toLowerCase()
      return cleanName.indexOf(searchText) > -1
    },
    removeTagFromSelected(tag) {
      let index = this.selectedTags.indexOf(tag)
      if (index >= 0) this.selectedTags.splice(index, 1)
    },
    tagFilter(item, queryText, itemText) {
      const cleanName = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return cleanName.indexOf(searchText) > -1
    },
    filterTagByCategory(e) {
      var filteredTags = null;
      if (e !== 0) {
        filteredTags = this.tags.filter(tag => tag.category.id === parseInt(e))
      } else {
        filteredTags = this.tags
      }
      this.filteredTags = filteredTags
    },
    cancelClicked() {
      this.$emit('dialog-clicked')
    },
    okClicked() {
      let selectedFilters = {
        fromDt: this.fromDateVal,
        thruDt: this.thruDateVal,
        onlyNeedsReview: this.onlyNeedsReview,
        showQCed: this.showQCed,
        includeInactive: this.includeInactive,  // IT-708
        retailer: this.selectedRetailer,
        rgidSearchFreeForm: this.rgidSearchFreeForm,
        respIdSearchFreeForm: this.respIdSearchFreeForm,
        question_id: this.question_id,
        tags: this.selectedTags,
        taggers: this.selectedTaggers,
        // IT-707 P2.4 — apply_group_filters already consumes all four, and
        // GroupCountQC already sends them through this same endpoint.
        projects: this.selectedProjects,
        jobs: this.selectedJobs,
        department: this.selectedDepartment,
        country: this.selectedCountry,
      }

      this.$emit('apply-filters', selectedFilters)
      this.$emit('dialog-clicked')
    }
  }
}
</script>

<style>
</style>
